@if (site) {
  <div class="container">
    <div class="main">
      <button mat-icon-button
        matTooltip="{{'back_to_sites' | transloco}}"
        class="material-symbols-outlined"
        (click)="onClickDeselectSite()">
        arrow_back
      </button>
      <div>
        <mat-card-title>
          <span style="position: relative; font-weight: 600">
            {{site.name}}
            <!--          <div class="emergency-badge" [style.background-color]="site.textColor"></div>-->
          </span>
        </mat-card-title>
        <mat-card-subtitle>
          {{site | sector}}
        </mat-card-subtitle>
      </div>
    </div>
    @if ((dateFormat$ | async); as dateFormat) {
      <div class="acquisition-date">
        <div>{{'latest_acquisition' | transloco}}</div>
        <div class="date">{{site.lastBatchDate | date:dateFormat}}</div>
      </div>
    }
    @if ((haveManyBatch$ | async)) {
      <reference-batch-selector></reference-batch-selector>
    }
    <div class="scrollable">
      <div class="modules">
        @if (
          !hasDetections &&
          (site | module: [inspectionModule.ARCAD]) &&
          !hasVolumes &&
          (site | module: [inspectionModule.PERREAD])
          ) {
          <div class="empty-state">
            <mat-icon>analytics</mat-icon>

            <div class="empty-state-content">
              <div class="empty-state-title">
                {{ 'no_analysis_data_title' | transloco }}
              </div>

              <p>
                {{ 'no_detection_data_description' | transloco }}
              </p>

              <p>
                {{ 'no_volume_data_description' | transloco }}
              </p>
            </div>
          </div>
        }
        @else if (
          !hasDetections &&
          (site | module: [inspectionModule.ARCAD])
          ) {
          <div class="empty-state">
            <mat-icon>search_off</mat-icon>

            <div class="empty-state-content">
              <div class="empty-state-title">
                {{ 'no_detection_data_title' | transloco }}
              </div>

              <p>
                {{ 'no_detection_data_description' | transloco }}
              </p>
            </div>
          </div>
        }
        @else if (
          !hasVolumes &&
          (site | module: [inspectionModule.PERREAD])
          ) {

          @if ((batchCount$ | async) == 1) {
            <div class="empty-state">
              <mat-icon>view_in_ar</mat-icon>

              <div class="empty-state-content">
                <div class="empty-state-title">
                  {{ 'no_volume_data_title' | transloco }}
                </div>

                <p>
                  {{ 'no_volume_data_description' | transloco }}
                </p>
              </div>
            </div>
          } @else {
            @if (!volumeSummary && !isLoadingVolumeSummary && !perreadPipelineAvailable) {
              <div class="empty-state">
                <div class="empty-state-content">
                  <p>
                    {{ 'missing_perread_data' | transloco }}
                  </p>
                  <button mat-button="filled"
                          (click)="onClickLaunchPerreadPipeline()">
                    <mat-icon>rocket_launch</mat-icon>
                    <span>{{'start_calculation' | transloco}}</span>
                  </button>
                </div>
              </div>
            }
            @if (!volumeSummary && !isLoadingVolumeSummary && perreadPipelineAvailable) {
              <div class="empty-state">
                <mat-icon>rocket_launch</mat-icon>
                <div class="empty-state-content">
                  <p>
                    {{ 'perread_pipeline_running' | transloco }}
                  </p>
                </div>
              </div>
            }
          }
        }

        <!-- Detections -->
        @if ((detectionCount$ | async)) {
          <div class="module">
            <div class="row">
              <div class="section-title">{{'detections' | transloco | uppercase}}</div>
            </div>
            <div style="padding-top: 15px; width: 100%;">
              <detection-summary [detectionSummary]="detectionSummary"></detection-summary>
              @if (detectionSummary && detectionSummary.densities) {
                <density-chart
                    class="density-chart"
                    [data]="detectionSummary.densities"
                    [label]="'density_chart_detections' | transloco"></density-chart>
              }
            </div>
            <detection-filters style="padding-top: 15px;"
              class="row">
            </detection-filters>
          </div>
        }
        <!-- Volumes -->
        @if (volumeCount$ | async) {
          <div class="module">
            <div class="row">
              <div class="section-title">{{'volumes' | transloco | uppercase}}</div>
            </div>
            <div style="padding-top: 15px; width: 100%;">
              <volume-summary [volumeSummary]="volumeSummary"></volume-summary>
              @if (volumeSummary.densities) {
                <density-chart
                  class="density-chart"
                  [data]="volumeSummary.densities"
                  [label]="'density_chart_volumes' | transloco"></density-chart>
              }
              <volume-color-ramp></volume-color-ramp>
            </div>
          </div>
        }
      </div>
    </div>
    <site-actions-bar></site-actions-bar>
  </div>
}
